import React from "react";
import { Container, Breadcrumb } from "react-bootstrap";
// import "./AboutBreadcrumb.css";

const BlogBreadcrumb = () => {
    return (
        <div className="about-breadcrumb-section">
            <Container className="heading-title">
                <h2 className="about-title text-center">
                    Blog
                    {/* <span className=" about-text">Us</span> */}
                </h2>
                <Breadcrumb>
                    <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href="/InternalBlogPage">Internal Blog</Breadcrumb.Item>
                    <Breadcrumb.Item active className="about-text">Blog</Breadcrumb.Item>
                </Breadcrumb>
            </Container>
        </div>
    );
};

export default BlogBreadcrumb;
